export default __webpack_public_path__ + "static/media/github_logo_white.57fdb053.svg";